module.exports = __webpack_public_path__ + "media/1x1/rw-997fe41b.svg";